<ng-container *ngIf="content$ | async as content; else loading">
  <div fxLayout="column" fxLayout.gt-sm="row" class="page">
    <div fxFlex="45" class="gallery-slider">
      <app-gallery-slider
        [images]="content.images"
        [info]="{ title: content.name, subTitle: content.subTitle }"
        [scrollText]="'Scroll to discover'"
      ></app-gallery-slider>
    </div>
    <div fxFlex="55" class="content-wrapper">
      <div class="content">
        <ng-container *ngFor="let section of content.content">
          <app-content [section]="section"></app-content>
        </ng-container>
      </div>
    </div>
    <app-bottom-nav [navItems]="content.content"></app-bottom-nav>
  </div>
</ng-container>

<ng-template #loading>
  <app-loader></app-loader>
</ng-template>
